export default function GlobalLicensing() {
  const cities = [
    { name: 'Singapore', region: 'Southeast Asia', icon: 'ri-building-line' },
    { name: 'Bangkok', region: 'Southeast Asia', icon: 'ri-building-line' },
    { name: 'Jakarta', region: 'Southeast Asia', icon: 'ri-building-line' },
    { name: 'Manila', region: 'Southeast Asia', icon: 'ri-building-line' },
    { name: 'Mumbai', region: 'South Asia', icon: 'ri-building-line' },
    { name: 'Dubai', region: 'Middle East', icon: 'ri-building-line' },
    { name: 'London', region: 'Europe', icon: 'ri-building-line' },
    { name: 'New York', region: 'North America', icon: 'ri-building-line' },
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="global-licensing" className="py-24 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
            <i className="ri-earth-line text-white mr-2 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-white" style={{ fontFamily: "'Inter', sans-serif" }}>
              Global Expansion
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Global Licensing Program
          </h2>
          <p className="text-base text-white/90 max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            After our successful launch in Kuala Lumpur, we're opening licensing opportunities for major cities worldwide. Bring <strong className="font-bold">KLCarPool</strong>'s proven carpooling technology to your city.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {cities.map((city, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center hover:bg-white/20 transition-all hover:-translate-y-1 border border-white/20"
            >
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className={`${city.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h4 className="text-sm font-bold text-white mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {city.name}
              </h4>
              <p className="text-xs text-white/70" style={{ fontFamily: "'Inter', sans-serif" }}>
                {city.region}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="text-base font-bold text-white mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Proven Technology
              </h4>
              <p className="text-sm text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                Battle-tested AI platform with verified success in Kuala Lumpur
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="text-base font-bold text-white mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Full Support
              </h4>
              <p className="text-sm text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                Complete training, technical support, and operational guidance
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h4 className="text-base font-bold text-white mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Scalable Model
              </h4>
              <p className="text-sm text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                Flexible licensing terms adapted to your city's unique needs
              </p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center px-8 py-4 bg-white text-teal-600 rounded-full text-sm font-medium hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Inquire About Licensing
              <i className="ri-arrow-right-line ml-2 text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
            <p className="text-xs text-white/70 mt-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact us to discuss licensing opportunities in your city
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
